import React, { useState } from 'react';
import { func, string, arrayOf } from 'prop-types';
import { useDispatch } from 'react-redux';
import { isEmail } from 'validator';
import { withLang } from '../../../i18n';
import ModalDialog from '../../ModalDialog';
import IsRequiredField from '../../IsRequiredField';
import { participantType } from '../../../constants/types';
import { setParticipantEmailAction } from '../../../actions';

import styles from './editParticipantDialog.module.css';
import { participantWarnings } from '../../../constants';

const SELECT_EMAIL_GROUP = 'selectEmailGroup';
const EXISTING_EMAIL_ID = 'existingEmailId';
const REGISTRY_EMAIL_ID = 'registryEmailId';

const EditParticipantDialog = ({
  participant, reservedEmails, translate: t, existingEmail, warning
}) => {
  const [dialogOpen, setDialogOpen] = useState(false);
  const [email, setEmail] = useState(participant.email || '');
  const dispatch = useDispatch();

  const handleChange = (e) => {
    setEmail(e.target.value);
  };

  const handleSetParticipantEmail =
    () => dispatch(setParticipantEmailAction(participant.studentNumber, email));

  const onConfirm = () => {
    handleSetParticipantEmail();
    setDialogOpen(false);
  };

  const onCancel = () => {
    setDialogOpen(false);
    setEmail(participant.email || '');
  };

  const isValidEmail = isEmail(email) && !reservedEmails.includes(email.toLowerCase());

  const getRadioInput = (id, value, label) => (
    <div className={styles.emailSelectionRow}>
      <input
        type="radio"
        name={SELECT_EMAIL_GROUP}
        id={id}
        value={value}
        onChange={handleChange}
        checked={email === value}
      />
      <label htmlFor={id} className={styles.emailLabel}>
        {value}
        <span className={styles.emailSource}>{`(${label})`}</span>
      </label>
    </div>
  );

  const selectMode = existingEmail && warning === participantWarnings.CHANGING_EMAIL;
  const isValid = (selectMode) ? true : isValidEmail;

  return (
    <div>
      <button
        type="button"
        onClick={() => setDialogOpen(true)}
        className="icon--edit iconButton"
        title={t('common.edit')}
      />
      <ModalDialog
        isLarge={false}
        isOpen={dialogOpen}
        onCancel={onCancel}
        onConfirm={onConfirm}
        isValid={isValid}
        cancelTranslationKey="common.cancel"
        confirmTranslationKey={selectMode ? 'common.select' : 'common.save'}
      >
        <h3>{t(`surveyParticipantsEditor.${selectMode ? 'selectEmail' : 'enterEmail'}`)}</h3>
        <div>
          <div className={styles.participantInfoRow}>
            <p>{t('common.name')}</p>
            <p>{participant.name}</p>
          </div>
          <div className={styles.participantInfoRow}>
            <p>{t('common.studentNumber')}</p>
            <p>{participant.studentNumber}</p>
          </div>
        </div>
        { selectMode ? (
          <div className={styles.emailSelection}>
            <div className={styles.emailSelectionTitle}>
              <p>
                {t('surveyParticipantsEditor.selectEmail')}
                <IsRequiredField />
              </p>
            </div>
            {getRadioInput(EXISTING_EMAIL_ID, existingEmail, t('header.siteTitle'))}
            {getRadioInput(REGISTRY_EMAIL_ID, email, t('surveyParticipantsEditor.studentRegistry'))}
          </div>
        )
          : (
            <div>
              <label htmlFor="email">{t('common.email')}</label>
              <IsRequiredField />
              <input
                id="email"
                type="text"
                value={email}
                onChange={handleChange}
                autoComplete="email"
              />
            </div>
          )}

      </ModalDialog>
    </div>
  );
};

EditParticipantDialog.propTypes = {
  participant: participantType.isRequired,
  existingEmail: string.isRequired,
  reservedEmails: arrayOf(string).isRequired,
  warning: string,
  translate: func.isRequired
};

EditParticipantDialog.defaultProps = {
  warning: ''
};

export default withLang(EditParticipantDialog);
